/** User */
export const UPDATE_ROLE = "updateRole"
export const UPDATE_ROLES = "updateRoles"
export const UPDATE_USER = "updateUser"
export const UPDATE_LOCALE = "updateLocale"
export const UPDATE_SHOPPING_TYPE = "updateShoppingTypeSelected"
export const UPDATE_PLANTS = "updatePlants"
export const UPDATE_SELECTED_PLANT = "updateSelectedPlant"
export const CLEAR_SHOPPING_TYPE = "clearShoppingType"
export const CLEAR_ROLE = "clearRole"
export const CLEAR_ROLES = "clearRoles"
export const GET_COST_CENTER_CODES = "getCostCenterCodes"
export const FETCH_PLANTS = "fetchPlants"
export const CLEAR_PLANTS = "clearPlants"
export const CLEAR_SELECTED_PLANT = "clearSelectedPlant"


// Cart
export const ADD_CART_DETAILS = "addCartDetails";
export const ADD_CART_STATUS = "addCartStatus";
export const UPDATE_COST_CENTER_CODES = "updateCostCenterCodes";
export const ADD_ITEM_TO_CART = "addItemToCart";
export const CHECK_VALID_MATERIAL_GROUPS_FOR_ASSET_ITEMS = "checkValidMaterialGroupsForAssetItems";
export const REMOVE_ITEM_FROM_CART = "removeItemFromCart";
export const UPDATE_WBS_MATERIAL_GROUPS = "updateWBSMaterialGroups";
export const IS_REWORK = "isRework";
export const CLEAR_CART_STATUS = "clearCartStatus";
export const CLEAR_CART_ITEMS = "clearCartItems";
export const CLEAR_CART_DETAILS = "clearCartDetails";
export const CLEAR_WBS_MATERIAL_GROUPS = "clearWBSMaterialGroups";